/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthSafetyQuestionsAndCategoriesDto } from '../../models/health-safety-questions-and-categories-dto';

export interface CreateHealthSafetyOrganization$Params {

/**
 * The customer id
 */
  customerId: number;
}

export function createHealthSafetyOrganization(http: HttpClient, rootUrl: string, params: CreateHealthSafetyOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<HealthSafetyQuestionsAndCategoriesDto>> {
  const rb = new RequestBuilder(rootUrl, createHealthSafetyOrganization.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HealthSafetyQuestionsAndCategoriesDto>;
    })
  );
}

createHealthSafetyOrganization.PATH = '/customers/{customerId}/health-safety-organization';
